import { FormField, MultiSelect, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useSnapshotTemplateDialogStore } from "../dialogs/SnapshotTemplateDialogStore";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { SnapshotTemplateId, REQUIRED_LABEL } from "../snapshotUtils";

const ProductTypes = observer(() => {
	const store = useSnapshotTemplateStore();
	const dialogStore = useSnapshotTemplateDialogStore();
	const { productTypes, selectedProductTypes, setSelectedProductTypes, snapshotTemplateId, productTypeLocalizedLabel } = store;
	const errorMsg = dialogStore?.productTypeErrorMessage || "";
	const isStyle = snapshotTemplateId === SnapshotTemplateId.Style;
	const placeHolder = isStyle ? "3DSelectStypeTypes" : "3DSelectMaterialTypes";	

	return (
		<FormField
			control={(
				<MultiSelect
					limitTags={2}
					onChange={setSelectedProductTypes}
					options={productTypes}
					placeHolderRes={placeHolder}
					value={selectedProductTypes}
				/>
			)}
			fullWidth
			invalidMessage={errorMsg}
			label={<Text bold text={productTypeLocalizedLabel} />}
			labelPlacement="top"
			required
			sx={REQUIRED_LABEL}
		/>
	);
});

export default ProductTypes;